import {forwardRef} from "react";
import PropTypes from "prop-types";
import {NumberFormatBase, useNumericFormat, usePatternFormat} from "react-number-format";

const persianNumeral = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
function PersianNumericFormat(props) {
    const { format, removeFormatting, ...rest } = useNumericFormat(props);

    // const _format = (val) => {
    //     const _val = format(val);
    //     return _val.replace(/\d/g, ($1) => persianNumeral[Number($1)]);
    // };
    // const _removeFormatting = (val) => {
    //     const _val = val.replace(new RegExp(persianNumeral.join("|"), "g"), ($1) =>
    //         persianNumeral.indexOf($1)
    //     );
    //
    //     return removeFormatting(_val);
    // };

    return (
        <NumberFormatBase
            format={format}
            removeFormatting={removeFormatting}
            {...rest}
        />
    );
}

export const NumericFormatCustom = forwardRef(function NumericFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
        <PersianNumericFormat
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            allowNegative={false}
            decimalScale={0}
            allowLeadingZeros
            thousandSeparator
            valueIsNumericString
            {...other}
        />
    );
});
NumericFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export const PatternFormatCustom = forwardRef(function PatternFormatCustom(props, ref) {
    const { onChange, ...other } = usePatternFormat(props);

    return (
        <NumberFormatBase
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            valueIsNumericString
            {...other}
        />
    );
});
PatternFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};